export default __webpack_public_path__ + "static/media/add-watchlist-black.8834427b.svg";